var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"Preview"},[(_vm.flow)?_c('ChartDisplay',_vm._b({},'ChartDisplay',{
			flow: _vm.flow
		},false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }